<template>
  <div class="filtering">
    <ul
      class="filters"
      :class="{ 'filters--no-scroll' : activeCategory.length }"
    >
      <li
        class="filters__category category"
        v-for="(filterCategory, categoryIndex) in filters"
        :key="filterCategory.name"
        v-show="filterCategory.name !=='Artikelprijsgroep' "
      >
        <div
          class="category__wrapper"
          @click="activeCategory = filterCategory.name"
        >
          <div class="category__name">{{filterCategory.name}}</div>
          <div class="category__filters">{{activeFilters(filterCategory.name)}}</div>
        </div>
        <a
          href='#'
          class="category__clear"
          v-if="activeFilters(filterCategory.name).length"
          @click="clear(filterCategory.name)"
        >{{resource('clear')}}</a>
        <div
          class="category__overlay"
          v-show="activeCategory === filterCategory.name"
        >
          <ul class="category__list">
            <li
              v-for="(filter, filterIndex) in filterCategory.facets"
              :key="filter.name"
              class="filter"
              :class="{ 'filter--active' : filter.isSelected }"
            >
              <label class="filter__wrapper">
                <input
                  type="checkbox"
                  :value="{ category: filterCategory.name, filter: filter }"
                  v-model="filters[categoryIndex].facets[filterIndex].isSelected"
                  class="filter__checkbox"
                >
                <div class="filter__name">{{filter.name}}</div>
                <div class="filter__hits">({{filter.hits}})</div>
              </label>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="filtering__buttons">
      <button
        class="button button--cancel button--large"
        v-if="activeCategory"
        @click="activeCategory = ''"
      >
        {{resource('allFilters')}}
      </button>
      <button
        class="button button--secondary button--large"
        @click="$emit('close')"
      >
        {{showResults(totalHits)}}
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.filtering {
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  &__buttons {
    padding: $component;
    background: #f5f5f5;
    display: flex;
    .button {
      flex: 1 1 auto;
      justify-content: center;
      & + .button {
        margin-left: $component;
      }
    }
  }
}
.filters {
  padding: 0;
  margin: 0;
  position: relative;
  overflow: auto;
  flex: 1 1 auto;
  &--no-scroll {
    overflow: hidden;
  }
  &__category {
    background: #fff;
    border-bottom: 1px solid #ccc;
    &:first-child {
      border-top: 1px solid #ccc;
    }
  }
}
.category {
  display: flex;
  align-content: stretch;
  width: 300px;
  &__wrapper {
    display: flex;
    flex-direction: column;
    padding: $content;
    justify-content: center;
    cursor: pointer;
    flex: 1 1 auto;
    &:not(:only-child) {
      max-width: 80%;
    }
  }
  &__filters {
    font-size: $fs-1;
    color: $secondary;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
  }
  &__list {
    padding: 0;
    margin: 0;
    flex: 1 1 auto;
    overflow: auto;
  }
  &__clear {
    align-self: center;
    padding: $content;
    color: $text;
    flex: 0 0 auto;
  }
}

.filter {
  border-bottom: 1px solid #ccc;
  &--active {
    color: #00a3d2;
    .filter__hits {
      color: #00a3d2;
    }
  }
  + .filter {
    margin-left: 0;
  }
  &:first-child {
    border-top: 1px solid #ccc;
  }
  &__wrapper {
    display: flex;
    padding: $content;
    align-items: center;
    cursor: pointer;
  }
  &__checkbox {
    margin-right: $content;
  }
  &__hits {
    color: rgba($text, 0.8);
    font-size: $fs-2;
    margin-left: $component;
  }
}
</style>
<script>
export default {
	name: 'nc-filtering',
	model: {
		prop: 'filters',
		event: 'setSelection'
	},
	props: {
		filters: Array,
		totalHits: {
			type: Number,
			default() {
				return 0
			}
		}
	},
	methods: {
		activeFilters (category) {
			let filter = this.filters.find(i => i.name === category)
			let facets = filter.facets.filter(i=> i.isSelected).map(i=>i.name).join(', ')
			return facets
		},
		clear (category) {
			let filter = this.filters.find(i => i.name === category)
			filter.facets.forEach(i=>{
				i.isSelected = false
			})
		},
		showResults (totalHits) {
			if (totalHits > 1) {
				return this.resource('showResults', totalHits)
			} else {
				return this.resource('showResult')
			}
		}
	},

	computed: {
		resource () {
			return (input, replace) => {
				let lang = this.$store.getters.language
				let translate = this.res[lang][input]
				if (translate) {
					translate = translate.replace('[0]', replace)
					return translate
				}
				return input
			}
		},
	},
	data () {
		return {
			activeCategory: '',
			res: {
				nl: {
					allFilters: 'Alle filters',
					showResults: 'Toon [0] resultaten',
					showResult: 'Toon 1 resultaat',
					clear: 'wis'
				},
				fr: {
					allFilters: 'Tous les filtres',
					showResults: 'Afficher [0] résultats',
					showResult: 'Afficher 1 résultat',
					clear: 'sûr'
				}
			}
		}
	}
}
</script>
